/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Switch,
  Tab,
  Tabs,
} from "@material-ui/core";
import { Add, GetApp } from "@material-ui/icons";
import ContentsDialog from "./ContentsDialog";
import * as contentsDUCK from "../../../redux/ducks/contents.duck";
import { setLoader } from "../../../redux/ducks/load.duck";
import FilterDataTable from "../../utils/FilterDataTable";
import { setAlert } from "../../../redux/ducks/alert.duck";
import CustomTable from "../../utils/CustomTable";
import NotifyModal from "./NotifyModal";
import useContentsMaintenance from "./hooks/useContentsMaintenance";
import { getActionColumns, getColumns } from "./utils/Contents-Columns";
import { downloadContentFocusAreaAudit } from "../../crud/api/content.crud";

const Contents = ({ contentActions, settingLoader, setAlert, school }) => {
  const {
    openDialog,
    htmlContent,
    setHtmlContent,
    dialog,
    setNotify,
    setPage,
    tabValue,
    onSearch,
    // eslint-disable-next-line no-unused-vars
    _onGetContents,
    setIsProAthleteContent,
    isProAthleteContent,
    setTabValue,
    query,
    setQuery,
    categories,
    notify,
    deleteCont,
    handleOpenNotify,
    contentsList,
  } = useContentsMaintenance({
    contentActions,
    settingLoader,
    setLoader,
    school,
  });

  const columns = getColumns({});
  const actionColumns = getActionColumns({
    openDialog,
    setHtmlContent,
    deleteCont,
    handleOpenNotify,
  });

  // eslint-disable-next-line eqeqeq
  if (tabValue !== 4 && columns.find((x) => x.name === "author") == null) {
    columns.splice(
      3,
      0,
      {
        name: "duration",
        label: "Duration",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "author",
        label: "Author",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => value && <>{value.author}</>,
        },
      }
    );
  } else if (tabValue === 4) columns.splice(3, 2);

  const HtmlDialogContent = () => (
    <Dialog
      id="view_content_dialog"
      open={Boolean(htmlContent)}
      onClose={() => setHtmlContent("")}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Content</DialogTitle>
      <DialogContent>
        <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </DialogContent>
    </Dialog>
  );

  const [downloadingAudit, setDownloadingAudit] = React.useState(false);

  const handleSwitchChange = () => {
    setIsProAthleteContent(!isProAthleteContent);
  };

  const handleDownloadAudit = () => {
    setDownloadingAudit(true);
    downloadContentFocusAreaAudit(
      () => setDownloadingAudit(false),
      () => setDownloadingAudit(false)
    );
  };

  return (
    <>
      <Paper className="mb-3" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: "5px", zIndex: "1000" }}>
          <Switch
            id="proAthleteContent"
            name="proAthleteContent"
            value={isProAthleteContent}
            onChange={handleSwitchChange}
            color="primary"
          />
          <span>Pro Athlete content</span>
        </div>

        <Tabs
          value={tabValue ?? false}
          onChange={(e, value) => {
            settingLoader(true);
            setTabValue(value);
          }}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="auto"
          centered
        >
          {categories.map((c) => (
            <Tab
              id={`tab_content_mind_selector_${c.key}`}
              key={`tab_content_mind_selector_${c.key}`}
              value={c.key}
              label={c.name}
            />
          ))}
          <Tab id="tab_content_tip_selector" value={4} label="TIP" />
        </Tabs>
      </Paper>
      <div className="pb-4 d-flex justify-content-between align-items-end">
        <FilterDataTable query={query} setQuery={setQuery} search={onSearch} />
        <div className="d-flex align-items-end" style={{ gap: 8 }}>
          <Button
            id="download_focus_area_audit_btn"
            variant="outlined"
            color="primary"
            onClick={handleDownloadAudit}
            disabled={downloadingAudit}
            startIcon={
              downloadingAudit ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <GetApp />
              )
            }
          >
            {downloadingAudit ? "Downloading…" : "Download focus-area audit"}
          </Button>
          <Button
            id="create_content_btn"
            variant="contained"
            color="secondary"
            onClick={() => openDialog("create")}
          >
            <Add /> New Content
          </Button>
        </div>
      </div>
      <CustomTable
        title="Polls"
        columns={[...columns, ...actionColumns]}
        data={contentsList.items}
        page={contentsList.page}
        count={contentsList.count}
        setPage={setPage}
      />
      {(dialog === "editing" || dialog === "create") && (
        <ContentsDialog
          mode={dialog}
          setDialog={openDialog}
          page={contentsList.page}
        />
      )}
      <HtmlDialogContent />
      <NotifyModal
        open={notify}
        setOpen={setNotify}
        isContentProAthlete={isProAthleteContent}
      />
    </>
  );
};

const mapStateToProps = (store) => {
  return {
    contents: store.contents_.contents,
  };
};

const mapDispatchToProps = (dispatch) => ({
  settingLoader: bindActionCreators(setLoader, dispatch),
  contentActions: bindActionCreators(contentsDUCK.actions, dispatch),
  setAlert: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contents);
